module.exports = __webpack_public_path__ + "img/12.a012c555.png";